/**
 * Returns the currently single-selected table element.
 */
export const getSelectedTableElement = (): HTMLDivElement | null =>
    document.querySelector<HTMLDivElement>('.Table.selected-single');

/**
 * Queries an element within the currently single-selected table.
 */
export const querySelectedTableElement = <T extends Element>(selectors: string): T | null =>
    getSelectedTableElement()?.querySelector<T>(selectors) || null;

/**
 * Returns the active highlighted cell element within the selected table.
 */
export const getHighlightedCellElement = (): HTMLDivElement | null => querySelectedTableElement('.highlight');
export const getHighlightedFromTableDom = (tableDomElement: HTMLElement): HTMLDivElement | null =>
    tableDomElement.querySelector('.highlight');
